module.exports = __webpack_public_path__ + "static/media/calendar_blue.dd613bae.svg";